import calls from '@/backend/api-calls'

const state = () => ({
  suppliers: [],
  selected: [],
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  }
})

// getters
const getters = {
  supplierIds: state => {
    return state.suppliers.map(d => d.id);
  }
}

// actions
const actions = {
  getSuppliers: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.suppliers.get(parameters)
        .then(resp => {
          commit("setSuppliers", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addSupplier({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.suppliers.post(data, parameters)
        .then(resp => {
          commit("insertSupplier", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Supplier successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateSupplier: ({commit}, { supplierId, data }) => {
    return new Promise((resolve, reject) => {
      calls.supplier.put(supplierId, data).then(
        resp => {
          commit("insertUpdatedSupplier", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Supplier successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteSupplier: ({commit}, supplierId) => {
    return new Promise((resolve, reject) => {
      calls.supplier.delete(supplierId).then(
        resp => {
          commit("removeSupplier", supplierId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Supplier successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
  // toggleAllSelected: ({commit, getters}, value) => {
  //   if (value) {
  //     commit("selectAll", getters.bomIds);
  //   } else {
  //     commit("deselectAll");
  //   }
  // }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setSuppliers(state, data) {
    state.pagination = data.pagination;
    state.suppliers = data.results;
  },
  insertSupplier(state, data) {
    state.suppliers.push(data);
  },
  insertUpdatedSupplier(state, data) {
    state.suppliers.forEach((supplier, i) => {
      if (supplier.id == data.id) {
        state.suppliers.splice(i, 1, data);
      }
    })
  },
  removeSupplier(state, supplierId) {
    state.suppliers.forEach((supplier, i) => {
      if (supplier.id == supplierId) {
        state.suppliers.splice(i, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}